<template>
	<div class="bpEditor"> 
	
		<div style="height: 400px;">
			<screen ref="screen" :options="screenOptions" :markers="screenMarkers">
				
				<group :nodes="graph.nodes" :padding="{left: 10, right: 10, top: 50, bottom: 10}">
					<h1>group name </h1>
					
				</group>
					<!-- <circle cx="50" cy="50" r="50" fill="red"/> -->
					
					<edge v-for="edge in graph.edges" 
					:data="{
						from: graph.nodes[0],
						to: graph.nodes[1],
						fromAnchor: 'right',
						toAnchor: 'left',
						snap: 'circle',
						type: 'smooth',
					}" 
					:nodes="graph.nodes" :key="edge.id"></edge>

					<node v-for="node in graph.nodes" :data="node" :key="node.id" dir="down" type="basic" :dragThreshold=10 :margin=10>
						<card  header-classes="mb-5 mt-1" footer-classes="text-center mb-1 mt-5" style="border: 1px solid #01b0e0; border-radius:6px;">
							<div>node.id: {{node.id}}</div>
						</card>
					
					</node>
				
					<Label v-for="edge in graph.edges" :edge="edge" :id="edge.id" :key="edge.id"  :perc="20" :offset="{x: 0, y: 0}" :width="350" :rotate="false" align="center" >
						<h4>edge.id: {{edge.id}}</h4>
						<p >edge.from: {{edge.from}}</p>
						<p >edge.to: {{edge.to}}</p>
					</Label>
				
				
			</screen>
		</div>
	
		<span class="legend-badge badge badge-pill badge-primary mb-2"  @click="showLegend()">Легенда</span>

		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<!-- <span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">БП найдено: {{this.masApi_total}}</span> -->
		</div> 
		
		<div class="row" v-show="bShowFilter">
			<div class="col-12"><ReFilter
				:masAllFilterParams="masAllFilterParams"
				v-model="objGetParams"
				v-on:filterapply="OnFilterApply"
				name="bp_editor_copy"
			/></div>
		</div>
		
		
		<card class="Legend" v-if="legendIsVisib">
			<div class="col">
				<h6>Условные обозначения</h6>
				<div class="row align-items-center mx-0">
					<button class="ml-3 btn btn-icon btn-simple btn-primary"><i class="tim-icons icon-pencil"></i></button>
					<p> &mdash; редактор основных настроек бизнесс-процесса</p>
				</div>
				<div class="row align-items-center mx-0">
					<button class="ml-3 btn btn-icon btn-simple btn-warning"><i class="tim-icons icon-settings-gear-63"></i></button>
					<p> &mdash; редактор чек-листа бизнесс-процесса</p>
				</div>
				<div class="row align-items-center mx-0">
					<button class="ml-3 btn btn-icon btn-simple btn-warning"><i class="tim-icons icon-book-bookmark"></i></button>
					<p> &mdash; редактор нецелевого бизнесс-процесса</p>
				</div>
				<div class="row align-items-center mx-0">
					<button class="ml-3 btn btn-icon btn-simple btn-danger"><i class="tim-icons icon-trash-simple"></i></button>
					<p> &mdash; удаление бизнесс-процесса</p>
				</div>
				<div class="row align-items-center mx-0">
					<button class="ml-3 btn btn-icon btn-simple btn-warning"><i class="tim-icons icon-puzzle-10"></i></button>
					<p> &mdash; экспорт бизнесс-процесса</p>
				</div>
			</div>
		</card>
		<card v-if="this.BPList.length>0">
			<ReActionLabel v-for="(bp, bp_i) in BPList" :key="bp.id" class="col" style="max-width: 1250px;"
				:label="bp.name"
				:masActions="masActions[bp_i]"
				:profileCode="bp.staffProfile_id"
				:bpProfiles="arrbpProfiles"
				:bpId="bp.id"
				:labelGoTo="'/data/settings/bp_editor_copy/id/'+bp.id"
			/>
			
		</card>

		<div class="d-flex">
			<base-button class="" @click="AddBP()" type="success" simple>Создать услугу</base-button>
			<base-button class="" @click="ImportBP()" type="info" simple>Импортировать услугу</base-button>
		</div>
		
	</div>
</template>
<script>
import ReActionLabel from 'src/our_components/ReActionLabel.vue';
//import { Tooltip, Button } from 'element-ui';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import {eventEmitter} from "src/plugins/globalComponents.js";
//import { Screen, Node, Edge, Group, Label, Port, Markers, graph } from 'vnodes'
import { Screen, Node, Edge, Group, Label, Port, graph } from 'vnodes'
// import { Screen, Node, Edge, Group, Label, Port, Markers, graph } from 'node_modules/vnodes';

export default {
	name: 'bp_editor_copy-page',
	components: {
		ReActionLabel,
		ReFilter,
		ReFilterBtn,
		Screen, 
		Node, 
		Edge, 
		Group, 
		Label, 
		// Port, 
		//Markers, 
		// graph,
		// [Tooltip.name]: Tooltip,	
		// [Button.name]: Button	
	},
	data() {
	    return {
			BPList: [],
			masActions:[],
			legendIsVisib: false,
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			masApi_total:0,
			arrbpProfiles: [],
			graph: new graph(),
			screenOptions: {dblClickZoomEnabled: true},
			screenMarkers: [],
			BPgraph: ['BP1', 'BP2']
			// Group: new graph(),
		};
    },
	methods: {
		getBPList(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getCallCenterData',this.objGetParams);
				filter = this.objGetParams;
			} 

			this.$GVO.ApiCall('GET',{obj:'BP',flt:{'list':true,'showall':true, ...filter,}})
			.then((objApi) => {
				this.masApi_total = 0;

			    if(objApi.success === true){
					this.BPList = objApi.data.BP_DATA;
					this.masActions = [];

					// if(objApi.total!=undefined) { this.masApi_total=objApi.total; }

					for (let i = 0; i < this.BPList.length; i++) {
						this.masActions.push([{
							actionType: 'switcher',
							action_model: this.BPList[i].act=='1'?true:false,
							label_on: 'Вкл',
							label_off: 'Выкл',
							onClickApi: {apiMethod:'CHANGE_BP_ACT',apiParam:{obj:'BP',flt:{id:this.BPList[i].id}}},
						},
						{
							actionType: 'btn_edit',
							onClickApi: {apiMethod:'GOTO',apiParam:{obj:'local',to:'/data/settings/bp_editor/id/'+this.BPList[i].id+'/edit'}},
						},
						{
							actionType: 'btn_custom',
							icon:'icon-settings-gear-63',
							onClickApi: {apiMethod:'GOTO',apiParam:{obj:'local',to:'/data/settings/bp_editor/id/'+this.BPList[i].id+'/check-list'}},
						},
						{
							actionType: 'btn_custom',
							icon:'icon-book-bookmark',
							onClickApi: {apiMethod:'GOTO',apiParam:{obj:'local',to:'/data/settings/bp_editor/id/'+this.BPList[i].id+'/no-purpose'}},
						},
						{
							actionType: 'btn_del',
							onClickApi: {apiMethod:'DEL',apiParam:{obj:'BP',flt:{id:this.BPList[i].id}}},
						},
						{
							actionType: 'btn_custom',
							icon:'icon-puzzle-10',
							onClickApi: {apiMethod:'export_bp',apiParam:{obj:'BP',flt:{bp_id:this.BPList[i].id}}},
						}]);
					}
			    }
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		AddBP(){
			this.$router.push({path: '/data/settings/bp_editor/add'});
		},
		ImportBP(){
			let input = document.createElement('input');
			input.type = 'file';
			input.onchange = e => { 
				let file = e.target.files[0]; 
				let reader = new FileReader();
				reader.readAsText(file,'UTF-8');
				reader.onload = readerEvent => {
					let content = JSON.parse(readerEvent.target.result);
					//console.log( content );
					this.$GVO.ApiCall('BP.import_bp',{iData:content})
					.then((objApi) => {
						if(objApi.success === true){
							this.getBPList();
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			}
			input.click();
		},
		showLegend(){
			this.legendIsVisib = !this.legendIsVisib;
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_BP',{obj:'BP'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						// this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			//this.objGetParams = data;
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getBPList();
		},
		

	},
	mounted() {
		this.$GVO.ApiCall('cat.GET_BP_PROFILE_CAT',{ flt:{}}) 
		.then((objApi) => {
			this.arrbpProfiles = [];
			if(objApi.success === true){
				// console.log(objApi.data);
				
				this.arrbpProfiles = objApi.data;
				// for (let i = 0; i < objApi.data.length; i++) {
				// 	const element = objApi.data[i];
				// 	// console.log(this.bpProfiles);
				// 	this.arrbpProfiles[element.value] = element;
				// 	// this.arrbpProfilesthis.push([{objApi.data[i]}]);

				// }
				// this.getApiData();
				// console.log(this.bpProfiles);
				this.getBPList();
			}
		}).catch(errorObjApi => {console.error(errorObjApi);});

	    
		
	},
	
	created () {
	    this.graph.createNode('a')
	    this.graph.createNode('b')
	    this.graph.createEdge('a', 'b')
	    this.graph.graphNodes()
		// this.Group.createNode('BP1')
	    // this.Group.createNode('BP2')
	    // this.Group.createEdge('BP1', 'BP2')
		// this.Group.graphNodes()
		
	  }
};
</script>
<style>
.bpEditor {position: relative;}
.Legend {
	z-index: 10;
	position: absolute;
	border: 1px solid #01b0e0;
	max-width: 800px;
}
.Legend i { font-size: 18px;}
.legend-badge {cursor: pointer;}
</style>

